import { MonthTuple, mountInterval } from '@src/common/calendar';

export function computeVisibleRange(monthTuple: MonthTuple): { dateFrom: string; dateTo: string } {
  const interval = mountInterval(monthTuple);
  return {
    dateFrom: interval[0]!.dateString,
    dateTo: interval[interval.length - 1]!.dateString,
  };
}
